/**
 * lib/posthog.js — PostHog analytics integration (parallel to Mixpanel).
 *
 * Follows the same isSupported() guard pattern as Mixpanel.
 * Only initializes when REACT_APP_POSTHOG_ENABLED === "true" and
 * REACT_APP_POSTHOG_API_KEY is set. Never crashes if PostHog fails.
 */

let ph = null;
let ready = false;

function init() {
  try {
    const enabled = process.env.REACT_APP_POSTHOG_ENABLED;
    const key = process.env.REACT_APP_POSTHOG_API_KEY;
    if (enabled !== "true" || !key) return;

    const posthog = require("posthog-js").default;
    posthog.init(key, {
      api_host: "https://us.i.posthog.com",
      autocapture: false,
      capture_pageview: false,
      capture_pageleave: false,
      persistence: "localStorage",
      disable_session_recording: false,
    });
    posthog.startSessionRecording();
    ph = posthog;
    ready = true;
  } catch (e) {
    console.warn("PostHog init failed:", e);
  }
}

init();

export function isSupported() {
  return ready && ph !== null;
}

export function track(event, properties = {}) {
  if (!isSupported()) return;
  try {
    // Strip sensitive data
    const safe = { ...properties };
    delete safe.birthday;
    delete safe.birthday_date;
    delete safe.email;
    delete safe.lat;
    delete safe.lng;
    delete safe.latitude;
    delete safe.longitude;
    ph.capture(event, safe);
  } catch {}
}

export function identify(userId, traits = {}) {
  if (!isSupported()) return;
  try {
    // Strip sensitive data from traits
    const safe = { ...traits };
    delete safe.birthday;
    delete safe.birthday_date;
    delete safe.email;
    delete safe.lat;
    delete safe.lng;
    delete safe.latitude;
    delete safe.longitude;
    ph.identify(userId, safe);
  } catch {}
}

export function reset() {
  if (!isSupported()) return;
  try {
    ph.reset();
  } catch {}
}
